import { useState } from 'react';

export default function WhyLocal() {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <section id="why-local" className="py-16 md:py-[100px] bg-[#1A3A52] relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#D97642]/10 rounded-full blur-[100px] pointer-events-none" aria-hidden="true"></div>
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-white/5 rounded-full blur-[80px] pointer-events-none" aria-hidden="true"></div>
      <div className="max-w-[1100px] mx-auto px-4 sm:px-8 relative z-10">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-4 py-1.5 bg-[#D97642] text-white text-[13px] font-medium uppercase tracking-wide rounded-full">
            Your Indianapolis Neighbor
          </span>
        </div>

        <h2 className="text-[28px] sm:text-[36px] md:text-[42px] font-bold text-white text-center mb-6 md:mb-10">
          A Licensed Indianapolis Agent — Not a Call Center
        </h2>

        <p className="text-[16px] md:text-[18px] text-white/70 text-center max-w-[680px] mx-auto leading-[1.7] mb-10 md:mb-16">
          When you call Hoosier Life Insurance, you reach Benjamin Wright directly — a licensed Indiana agent who lives and works in this community. No 1-800 numbers, no transfers, no scripts. Benjamin serves Marion County, Hamilton County (Carmel, Fishers, Noblesville, Westfield), Hendricks County (Avon, Brownsburg), and all 92 Indiana counties by phone or video.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-12 md:mb-20">
          <div className="text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-[#D97642] rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-service-fill text-[28px] md:text-[32px] text-white" aria-hidden="true"></i>
            </div>
            <p className="text-[13px] uppercase text-white/50 mb-2 tracking-wide">Service Area</p>
            <p className="text-[16px] md:text-[17px] font-medium text-white leading-[1.6]">
              Central Indiana
            </p>
          </div>

          <div className="text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-[#D97642] rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-phone-fill text-[28px] md:text-[32px] text-white" aria-hidden="true"></i>
            </div>
            <p className="text-[13px] uppercase text-white/50 mb-2 tracking-wide">Phone</p>
            <a href="tel:+13176482983" className="text-[16px] md:text-[17px] font-medium text-white hover:text-[#D97642] transition-colors cursor-pointer">
              (317) 648-2983
            </a>
          </div>

          <div className="text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-[#D97642] rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-time-fill text-[28px] md:text-[32px] text-white" aria-hidden="true"></i>
            </div>
            <p className="text-[13px] uppercase text-white/50 mb-2 tracking-wide">Hours</p>
            <p className="text-[16px] md:text-[17px] font-medium text-white leading-[1.6]">
              Mon-Fri: 9AM – 5PM<br />
              Sat: 8AM – 1PM
            </p>
          </div>
        </div>

        {/* Lazy-load Google Map — only renders iframe after user clicks */}
        <div className="rounded-[16px] md:rounded-[24px] overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.3)] h-[300px] md:h-[420px] relative bg-[#0F2A3F]">
          {mapLoaded ? (
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d386000!2d-86.1581!3d39.9012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1700000000099!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Indianapolis Metro Service Area — Hoosier Life Insurance"
              className="w-full h-full"
            />
          ) : (
            <button
              onClick={() => setMapLoaded(true)}
              className="w-full h-full flex flex-col items-center justify-center gap-4 cursor-pointer group"
              aria-label="Load interactive map of Indianapolis service area"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#D97642]/20 rounded-full border border-[#D97642]/40 group-hover:bg-[#D97642]/30 transition-colors">
                <i className="ri-map-2-line text-[32px] text-[#D97642]" aria-hidden="true"></i>
              </div>
              <div className="text-center">
                <p className="text-white font-semibold text-[16px] mb-1">Indianapolis Service Area Map</p>
                <p className="text-white/50 text-[13px]">Click to load interactive map</p>
              </div>
              <span className="px-5 py-2.5 bg-[#D97642] text-white text-[14px] font-semibold rounded-lg group-hover:bg-[#C26638] transition-colors whitespace-nowrap">
                <i className="ri-map-pin-line mr-2" aria-hidden="true"></i>View Map
              </span>
            </button>
          )}
        </div>

        {/* Disclaimer */}
        <div className="mt-6 flex items-center justify-center gap-3 bg-white/10 rounded-xl px-6 py-4 border border-white/10">
          <i className="ri-phone-line text-[#D97642] text-[20px] shrink-0" aria-hidden="true"></i>
          <p className="text-[14px] text-white/80 text-center leading-relaxed">
            <strong className="text-white">No office visit needed</strong> — we come to you by phone, video, or in-home appointment
          </p>
        </div>
      </div>
    </section>
  );
}
